import React, { Component } from "react";
import Error from "./Error";

class Error403 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Error statusCode="403" message="Access Forbidden" />
      </React.Fragment>
    );
  }
}

export default Error403;
